<div class="orders-modal">
  <h2 mat-dialog-title>ربط الطلبات</h2>
  <div mat-dialog-content>
    <div class="form-group">
      <label for="" class="form-label">رقم الطلب</label>
      <ng-select bindLabel="name" (scrollToEnd)="onScrollPagination()" #selectOrder
        placeholder="يرجى تحديد اسم الفاحص " appendTo="body" [searchable]="true" (removed)="resetSearch()"
        (search)="searchtext()" (clear)="resetSearch()" (change)="orderData($event)" (open)="resetSearch()"
        [virtualScroll]="true" [clearable]="true">
        @for (order of orders; track order) {
          <ng-option [value]="order.id">
            {{order.reference_number}}
          </ng-option>
        }
      </ng-select>
    </div>
  </div>
  <div mat-dialog-actions>
    <div class="actions-double">
      <button class="btn btn-cancel" type="button" mat-dialog-close>إلغاء</button>
      <button class="btn btn-green" type="submit" [mat-dialog-close]="data">ربط</button>
    </div>
  </div>
</div>
